const dummyEvents = [
    {
        id: 1,
        title: "React Conference",
        description: "A deep dive into React.",
        cityName: "San Francisco",
        location: "Moscone Center",
        eventDate: "2024-08-15",
        capacity: 300,
        imageUrl: "https://via.placeholder.com/150",
        latitude: 37.7749,
        longitude: -122.4194,
        availableSeats: 50,
        cost: 100,
    },
    {
        id: 2,
        title: "Tech Meetup",
        description: "Local tech networking event.",
        cityName: "New York",
        location: "Brooklyn Tech Hub",
        eventDate: "2024-09-10",
        capacity: 100,
        imageUrl: "https://via.placeholder.com/150",
        latitude: 40.7128,
        longitude: -74.0060,
        availableSeats: 20,
        cost: 50,
    },
];

export default dummyEvents;
